export const label = {
    legend: 'legenda',
    odp: 'commessa',
    customer: 'cliente',
    article: 'articolo',
    stapling: 'pinzatura'
}